
import { useEffect, useState } from "react"

import { useParams } from "react-router-dom";
import { getTemplateData } from "../utils/constants";
import useLanguage from "../utils/useLanguage";
import ViewsRouter from "./viewsRouter";
import { getDomain, getDomainCode } from "../utils/utils";


export default function LiveController({postData=null,defaultType}){
    const params = useParams();
    const {t} = useLanguage();
    const TEMPLATE_DATA = getTemplateData(t);
    const [sseData,setSseData] = useState(null);
    const domainCode = getDomainCode(process.env.REACT_APP_DOMAIN);

    const catchData = (e)=>{
        if(e.data?.live){
            setSseData(e.data?.live ? e.data : null);
        }
    }

    const getQrData = ()=>{
        const d = getDomain(params?.domain);

        if(sseData?.live && !sseData?.static){
            return sseData 
        }else{
            try{
                return TEMPLATE_DATA[domainCode][sseData?.type || defaultType];
            }catch(e){
                return {};
            }
        }
    }

    useEffect(()=>{
        if(postData){
            setSseData(postData);
        }else{
            window.addEventListener("message",catchData,false);
        }
        return ()=>{
            if(!postData){window.removeEventListener('message',catchData)}
        }
    },[postData])

    return <ViewsRouter domain={domainCode} type={sseData?.type || defaultType} data={getQrData()} />

}